<template>
    <div class="main-cn">
        <div class="main-bd mg20" v-loading="loading">
            <el-form label-width="180px" ref="commonForm" :model="financeForm" :rules="financeRules" :disabled="financeForm.is_submit" size="small">
                <el-form-item label="订单编号：" prop="id" v-if="order_no">{{order_no}}</el-form-item>
                <el-form-item v-if="parseInt($route.query['id']) > 0 || parseInt($route.query['customer_id']) > 0" label="客户名称：" prop="customer_id">
                    <el-col :span="4">
                        <el-input v-model="financeForm.customer_name" :disabled="true"></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item v-else label="客户名称：" prop="customer_id">
                    <CustomerSelect :scenary="scenary" :onlyShow="onlyShow"
                                    :customerIdss="customer_name" v-model="financeForm.customer_id"
                                    @change="CustomerHandleChange($event)"></CustomerSelect>
                </el-form-item>
                <el-form-item label="订单类型：" prop="type">
                    <el-radio-group v-model="financeForm.type" @change="changeType" :disabled="parseInt($route.query['id']) > 0">
                        <el-radio :label="config.TYPE_TRY_OUT">试用</el-radio>
                        <el-radio :label="config.TYPE_FORMAL">正式(新单)</el-radio>
                        <el-radio :label="config.TYPE_RENEW">正式(续费)</el-radio>
                        
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="签单模式：" prop="sign_mode">
                    <el-radio-group v-model="financeForm.sign_mode" @change="changeSignMode" :disabled="parseInt($route.query['id']) > 0">
                        <el-radio :label="0">普通订单</el-radio>
                        <el-radio :label="1">代理自签单</el-radio>
                        <el-radio :label="2">代理代签单</el-radio>
                        <el-radio :label="3">经销订单</el-radio>
                    </el-radio-group>
                    &nbsp;&nbsp;
                    <el-tooltip placement="right">
                        <div slot="content">
                            普通订单：一般业务员正常开通的订单<br/><br/>
                            代理代签单：业务员录单且作为订单负责人，但由代理跟进客户的订单<br/><br/>
                            代理自签单：公司代理和个人代理为订单负责人的订单<br/><br/>
                            经销订单：公司经销商开通的订单
                        </div>
                        <i class="el-icon-info"></i>
                    </el-tooltip>
                </el-form-item>
            </el-form>
            <!--产品 基本 合同 tabs-->
            <div style="margin-left: 90px;">
                <el-tabs v-model="activeName" type="card" :before-leave="switchTab">
                    <el-tab-pane label="财务信息" name="finance">
                        <el-form ref="financeForm" label-width="200px" :disabled="financeForm.is_submit" :model="financeForm" :rules="financeRules" size="small">
                            <div style="margin-left: -80px">
                                <!--选择产品及配置star-->
                                <el-form-item label="状态：" style="margin-left:1px">
                                    <span>{{financeForm.is_submit ? '已提交' : '未提交'}}</span>
                                </el-form-item>
                                <el-form-item label="续约目标单：" prop="target_id" v-if="financeForm.type == config.TYPE_RENEW">
                                    <el-select v-model="financeForm.target_id" placeholder="请选择" @change="selectTarget">
                                        <el-option v-for="item in target_orders" :key="item.id" :label="item.id + ' (' + item.product_memo + ')'" :value="item.id" v-show="financeForm.customer_id == item.customer_id"></el-option>
                                    </el-select>
                                    <span style="color:#F59A23;margin-left: 30px;font-size: 12px;" v-if="!customer_id"><i class="el-icon-warning"></i>&nbsp;&nbsp;请填写客户名称，再选择续费目标订单</span>
                                    <span style="color:#7de2fb;margin-left: 60px;font-size: 12px;" v-if="target_contract_start_time">(合同时间：{{target_contract_start_time}} - {{target_contract_end_time}})</span>
                                </el-form-item>
                                <el-form-item :label="financeForm.revise_type != 'refund' ? '合作产品：' : '退款产品：'" prop="products" v-if="customer_id">
                                    <div v-if="financeForm.revise_type != 'refund'">
                                        <div :gutter="10" v-for="productGroup in groupedProducts" :key="productGroup.type_id" style="line-height: 20px;">
                                            <el-checkbox :indeterminate="productGroup.isIndeterminate" v-model="productGroup.checkAll" @change="handleCheckAllChange(productGroup)">{{ productGroup.type_name }}</el-checkbox>
                                            <el-checkbox-group v-model="productGroup.checkedCities" @change="handleCheckedCitiesChange(productGroup)" style="margin-left: 40px;line-height: 20px;">
                                                <el-checkbox v-for="product in productGroup.products" :label="product.id" :key="product.id" :disabled="product.code == 11">
                                                    {{ product.name }}
                                                    <span v-if="product.code == 11" style="color:red;">&nbsp;&nbsp;&nbsp;不能单独开通，特殊需要请开通‘项目（软件）’代替，产品时间将同步给数字化校园</span>
                                                    <el-tooltip v-else-if="product.memo" class="item" effect="dark" :content="product.memo" placement="top-start">
                                                        <i class="el-icon-info"></i>
                                                    </el-tooltip>
                                                </el-checkbox>
                                            </el-checkbox-group>
                                        </div>
                                    </div>
                                    <el-popover placement="top-start" trigger="click">
                                        <el-date-picker
                                            type="daterange"
                                            v-model="times"
                                            format="yyyy-MM-dd"
                                            value-format="yyyy-MM-dd"
                                            range-separator="至"
                                            start-placeholder="开始日期"
                                            end-placeholder="结束日期"
                                            @change="batchSetTime">
                                        </el-date-picker>
                                        <el-button type="text" slot="reference">批量设置产品时间</el-button>
                                    </el-popover>
                                    <el-table :data="financeForm.products">
                                        <el-table-column prop="name" label="产品名称"></el-table-column>
                                        <el-table-column prop="price" label="产品价格">
                                            <template slot-scope="scope">
                                                <el-input type="number" :disabled="scope.row.code == 11" v-model="scope.row.price" @change="priceChange(scope.row)" placeholder="请输入价格"></el-input>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="effect_at" label="合作时间" width="300">
                                            <template slot-scope="scope">
                                                <el-date-picker
                                                    type="daterange"
                                                    v-model="scope.row.effect_at"
                                                    format="yyyy-MM-dd"
                                                    value-format="yyyy-MM-dd"
                                                    range-separator="至"
                                                    start-placeholder="开始日期"
                                                    end-placeholder="结束日期"
                                                    :clearable="false"
                                                    @change="timeChange($event, scope.row)" 
                                                    :disabled="scope.row.disabled || scope.row.code == 11"
                                                    style="width:280px;">
                                                </el-date-picker>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="版本" prop="type" >
                                            <template slot-scope="scope">
                                                <el-radio-group v-model="scope.row.type" v-if="scope.row.code == config.XWT_PRODUCT_CODE || scope.row.code == config.ZUJUAN_PRODUCT_CODE">
                                                    <el-radio :label=1>标准版</el-radio>
                                                    <el-radio :label=2>额度版</el-radio>
                                                </el-radio-group>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="refund_amount" label="退款金额" v-if="financeForm.revise_type == 'refund'">
                                            <template slot-scope="scope">
                                                <el-input type="number" :disabled="true" v-model="scope.row.refund_amount"></el-input>
                                            </template>
                                        </el-table-column>
                                        <el-table-column center label="操作">
                                            <template slot-scope="scope">
                                                <div>
                                                    <el-button v-if="scope.row.code != 11" type="text" @click="handleDeleteProduct(scope.row.id)">删除</el-button>
                                                </div>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </el-form-item>
                                <el-form-item label="客户联系人：" prop="contact_name">
                                    <el-col class="line" :span="4">
                                        <el-select v-model="financeForm.contact_name" placeholder="请选择" @change="selectCustomerSign">
                                            <el-option v-for="item in customer_contracts" :key="item.id" :label="item.name" :value="item.id" v-show="financeForm.customer_id == item.customer_id"></el-option>
                                        </el-select>
                                    </el-col>
                                    <el-col class="inline-item" :span="8">
                                        联系电话：<span>{{(financeForm.customer_mobile)?financeForm.customer_mobile:'无'}}</span>
                                    </el-col>
                                </el-form-item>
                                <el-form-item label="成交来源：" prop="source" class="inline-item">
                                    <el-radio-group v-model="financeForm.source">
                                        <el-radio :label="1">线索转化</el-radio>
                                        <el-radio :label="2">业务员自拓</el-radio>
                                        <el-radio :label="3">客户转介绍</el-radio>
                                        <el-radio :label="4">学海行舟公益行</el-radio>
                                        <el-radio :label="5">国培教育</el-radio>
                                        <el-radio :label="6">甘肃省平台</el-radio>
                                        <el-radio :label="7">400官网高价值线索</el-radio>
                                        <el-radio :label="8">运营孵化高价值线索</el-radio>
                                        <el-radio :label="9">龙岗区教育局</el-radio>

                                    </el-radio-group>
                                    &nbsp;&nbsp;
                                    <el-tooltip placement="right">
                                        <div slot="content">
                                            线索转化：通过联系申请线索与客户建立联系并促成成交的<br/><br/>
                                            业务员自拓：通过面销等方式与客户建立联系，并促成成交的<br/><br/>
                                            客户转介绍：经由其他客户介绍与客户建立联系并促成成交的<br/><br/>
                                            学海行舟公益行：机构提供的精准客户<br/><br/>
                                            国培教育：机构提供的精准客户
                                        </div>
                                        <i class="el-icon-info"></i>
                                    </el-tooltip>
                                </el-form-item>
                                <el-form-item label="开通学段：" v-if="financeForm.type != config.TYPE_TRY_OUT" class="inline-item" prop="open_xd">
                                    <el-checkbox-group v-model="financeForm.open_xd">
                                        <el-checkbox label="1">小学</el-checkbox>
                                        <el-checkbox label="2">初中</el-checkbox>
                                        <el-checkbox label="3">高中</el-checkbox>
                                        <el-checkbox label="4">中职</el-checkbox>
                                    </el-checkbox-group>
                                </el-form-item>
                                <el-form-item label="学校规模：" v-if="financeForm.type != config.TYPE_TRY_OUT">
                                    <el-col class="inline" style="margin-left:-90px" :span="6">
                                        <el-form-item label="班级数：" class="inline-item" prop="class_num">
                                            <el-input type="number" style="width: 150px" v-model="financeForm.class_num" placeholder="请输入班级数"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col class="inline" :span="12">
                                        <el-form-item label="教师数：" class="inline-item" prop="teacher_num">
                                            <el-input type="number" style="width: 150px" v-model="financeForm.teacher_num" placeholder="请输入教师数"></el-input>
                                            <el-tooltip placement="right">
                                                <div slot="content">
                                                    据实填写学校的班级、教师数，其中教师数应与教师账号绑定数一致<br/><br/>
                                                    （注：若绑定账号只有学校的公用账号，可与教师数不一致）<br/>
                                                </div>
                                                <i class="el-icon-info"></i>
                                            </el-tooltip>
                                        </el-form-item>
                                    </el-col>
                                    
                                </el-form-item>
                                <el-form-item label="销售额：" v-if="financeForm.type != config.TYPE_TRY_OUT" class="inline-item" prop="total_amount">
                                    <el-input class="inline-input" disabled style="width: 205px"
                                              v-model="financeForm.total_amount"
                                              placeholder="请输入销售额"></el-input>
                                </el-form-item>
                                <el-form-item label="退款金额：" v-if="financeForm.type != config.TYPE_TRY_OUT && financeForm.revise_type == 'refund'" class="inline-item" prop="refund_amount">
                                    <el-input class="inline-input" disabled style="width: 205px"
                                              v-model="financeForm.refund_amount"
                                              placeholder="请输入退款金额"></el-input>
                                </el-form-item>
                                <el-form-item label="应续金额：" v-if="financeForm.type == config.TYPE_RENEW" class="inline-item" prop="to_renew_amount">
                                    <el-input class="inline-input" disabled style="width: 205px"
                                              v-model="financeForm.to_renew_amount"
                                              placeholder="请输入应续金额"></el-input>
                                </el-form-item>
                                <el-form-item  v-if="financeForm.type != config.TYPE_TRY_OUT">
                                    <template #label><span><span style="color:#F56C6C">*</span> 业绩信息：</span></template>
                                    <el-col class="inline" :span="7" :offset="1">
                                        <el-form-item label="总新增业绩额：" class="inline-item" prop="pfm_total_amount">
                                            <el-input type="number" style="width: 160px" v-model="pfm_total_amount" disabled></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col class="inline" :span="7">
                                        <el-form-item label="总续费业绩额：" class="inline-item" prop="renew_total_amount">
                                            <el-input type="number" style="width: 160px" v-model="renew_total_amount" disabled></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col class="inline" :span="7" v-if="financeForm.type == config.TYPE_RENEW">
                                        <el-form-item label="总续费完成额：" class="inline-item" prop="finish_total_amount">
                                            <el-input type="number" style="width: 160px" v-model="finish_total_amount" disabled></el-input>
                                            <el-tooltip placement="right">
                                                <div slot="content">
                                                    续费订单才需填写续费完成额，填写金额应为上一订单的校网通产品价格+二一组卷+校本产品价格，<br/><br/>
                                                    若本次续费金额减少则填写为本次合作订单中校网通、二一组卷、校本产品价格之和<br/>
                                                </div>
                                                <i class="el-icon-info"></i>
                                            </el-tooltip>
                                        </el-form-item>
                                    </el-col>
                                </el-form-item>
                                <!--添加协作人start-->
                                <el-form-item prop="user">
                                    <el-button type="text" @click="addCorp" v-if="financeForm.type != config.TYPE_TRY_OUT">添加协作人</el-button>
                                    <el-table :data="financeForm.user" :loading="user_loading">
                                        <el-table-column prop="no" label="编号"></el-table-column>
                                        <el-table-column prop="status_memo" label="负责人/协作人">
                                            <template slot-scope="scope">
                                                <OrderUserSelect :uid="scope.row.user_id" @change="CorpHandleChange($event, scope.row)" :key="scope.row.no"></OrderUserSelect>
                                            </template>
                                        </el-table-column>
                                        <el-table-column v-if="financeForm.type != 1" prop="pfm_amount" label="新增业绩额">
                                            <template slot-scope="scope">
                                                <el-input size="small" type="number" v-model="scope.row.pfm_amount"  placeholder="请输入新增业绩额"></el-input>
                                            </template>
                                        </el-table-column>
                                      <el-table-column v-if="financeForm.type != 1" prop="renew_amount">
                                           <template slot="header">
                                               <span>新增续费额</span>
                                               <span style="color: #F56C6C; margin-left: 4px;font-size: 11px;" v-if="financeForm.type != 1&&financeForm.type != 2">请检查续费金额</span>
                                           </template>
                                            <template slot-scope="scope">
                                                <el-input size="small" type="number" v-model="scope.row.renew_amount"  placeholder="请输入新增续费额"></el-input>
                                            </template>
                                        </el-table-column>
                                        <el-table-column v-if="financeForm.type == 3" prop="finish_amount" label="续费完成额">
                                            <template slot-scope="scope">
                                                <el-input size="small" type="number" v-model="scope.row.finish_amount"  placeholder="请输入续费完成额"></el-input>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="is_cooperator_str" label="业务员角色"></el-table-column>
                                        <el-table-column center label="操作">
                                            <template slot-scope="scope">
                                                <div v-if="scope.row.is_cooperator == 1">
                                                    <el-button type="text" size="small" v-show="Acs('/order/del-corp')" @click="handleDelCorp(scope.row)">删除</el-button>
                                                </div>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </el-form-item>
                                <!--添加协作人end-->
                                <el-form-item label="合同时间：" label-width="180px" prop="contract_time" v-if="financeForm.type != config.TYPE_TRY_OUT">
                                    <el-date-picker
                                        type="daterange"
                                        v-model="financeForm.contract_time"
                                        format="yyyy-MM-dd"
                                        value-format="yyyy-MM-dd"
                                        range-separator="至"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期"
                                        disabled>
                                    </el-date-picker>
                                </el-form-item>
                                <!--选择产品及配置end-->
                                <!--添加回款计划start-->
                                <el-form-item label="回款计划：" prop="plan_pay" class="payRequired" v-if="financeForm.type != config.TYPE_TRY_OUT">
                                    <el-button type="text" @click="addPayPlan">添加回款计划</el-button>
                                    <el-tooltip placement="right">
                                        <div slot="content">
                                            据实填写回款计划 若为分期回款 则按时间、金额划分录入<br/>
                                        </div>
                                        <i class="el-icon-info"></i>
                                    </el-tooltip>
                                    <pay-plan-table :repayPlan="financeForm.plan_pay"
                                                    @handleDel="handleDeletePay"></pay-plan-table>
                                </el-form-item>
                                <!--添加回款计划end-->
                                <!--发票信息-->
                                <el-form-item label="发票信息：" prop="invoice" v-if="financeForm.type != config.TYPE_TRY_OUT">
                                    <el-button type="text" @click="dialogInvoiceTable">添加发票信息 </el-button>
                                    <el-tooltip placement="right">
                                        <div slot="content">
                                            录入的发票金额合计需与合同金额一致，发票信息需准确、完整填写<br/>
                                        </div>
                                        <i class="el-icon-info"></i>
                                    </el-tooltip>
                                    <!-- 添加表单 -->
                                    <invoice-table :invoiceForm="invoiceForm" v-if="dialogInvoiceVisible"
                                                   :customer_id="customer_id"
                                                   :contract-amount="financeForm.total_amount"
                                                   :invoices="financeForm.invoice"
                                                   @handleAddInvoice='addInvoice'></invoice-table>
                                    <!-- 展示表单 -->
                                    <invoice-show-table v-if="this.$route.path =='/order/revise' || this.$route.path =='/order/create' ||this.$route.path =='/order/edit' || isshowinvoice" :invoice='financeForm.invoice'
                                                        @handleDeleteInvoice='handleDeleteInvoice'
                                                        @handleEditInvoice='handleEditInvoice'></invoice-show-table>
                                </el-form-item>
                                <!--发票信息-->
                                <!--快递信息-->
                                <el-form-item label="地址信息：" prop="express" v-if="financeForm.type != config.TYPE_TRY_OUT">
                                    <el-button type="text" @click="dialogExpressTable">添加快递信息</el-button>
                                    <el-tooltip placement="right">
                                        <div slot="content">
                                            按实际邮寄的地址、联系人及快递方式填写，若为电子合同无需邮寄则在备注信息栏说明<br/>
                                        </div>
                                        <i class="el-icon-info"></i>
                                    </el-tooltip>
                                    <!-- 添加表单 -->
                                    <express-table  :expressForm='expressForm' v-if="dialogExpressVisible"
                                                   @handleAddExpress='addExpress'></express-table>
                                    <!-- 展示表单 -->
                                    <express-show-table v-if="financeForm.type != config.TYPE_TRY_OUT" :express='financeForm.express'
                                                        @handleDeleteExpress='handleDeleteExpress'
                                                        @handleShowExpress='handleShowExpress'></express-show-table>
                                </el-form-item>
                                <!--备注信息-->
                                <el-form-item label="备注信息：" class="inline-item" prop="memo">
                                    <el-input type="textarea" v-model="financeForm.memo" placeholder="其他情况说明（例：排课升级、无需开票、无需邮寄、使用代理合同及订单其他特殊情况说明）"></el-input>
                                </el-form-item>
                                <el-form-item v-if="$route.path=='/order/revise'" :label="financeForm.revise_type != 'refund' ? '修订理由：' : '退款理由：'" class="inline-item" prop="reason">
                                    <el-input class="inline-input" type="textarea" :rows="2" v-model="financeForm.reason"></el-input>
                                </el-form-item>
                                <el-form-item label="附件：" prop="file_list" v-if="($route.path=='/order/revise' || $route.path=='/order/create' || $route.path=='/order/edit'|| $route.path=='/order/renew' || $route.path=='/order/detail') && financeForm.type != config.TYPE_TRY_OUT">
<el-upload class="upload-demo" name="contractFile" 
    action="api/common/upload-contract" 
    :headers="headers" 
    :on-error="uploadError" :on-success="uploadFinanceSuccess" 
    :on-preview="handlePreview" :on-remove="handleFinanceRemove" :file-list="financeForm.file_list" 
    :before-upload="beforeUpload" list-type="text" multiple>
    <el-button type="primary">点击上传</el-button>
    <div slot="tip" class="el-upload__tip">上传pdf,docx,doc格式文档或JPG,JPEG,PNG图片,单个文件最大支持50MB,上传请耐心等待</div>
  </el-upload>
                                </el-form-item>
                                <el-form-item>
                                    <el-button type="primary" @click="submitFinance('financeForm')" :disabled="financeForm.is_submit || uploadCount > 0">提交</el-button>
                                </el-form-item>
                            </div>
                        </el-form>
                    </el-tab-pane>
                    <el-tab-pane label="合同附件" v-if="financeForm.type != config.TYPE_TRY_OUT" name="contract">
                        <el-form ref="contractForm" label-width="180px" :disabled="contractForm.is_submit"
                                 :model="contractForm" :rules="contractRules">
                            <!--合同附件上传-->
                            <div style="margin-left: -90px;">
                                <el-form-item label="状态：" style="margin-left:1px">
                                    <span>{{contractForm.is_submit?'已提交':'未提交'}}</span>
                                </el-form-item>
                                <el-form-item label="合同编号：" style="margin-left:1px" prop="contract_number">
                                    <el-col :span="4">
                                       <el-input
                                                   v-model="contractForm.contract_number"
                                                   :disabled="contractForm.is_auto_contract_number">
                                               </el-input>
                                    </el-col>
                                    <!--el-button v-if="contractForm.order_id && contractForm.contract_number && !contractForm.is_submit"
                                               type="danger" @click="clear">清除编号记录
                                    </el-button-->
                                </el-form-item>
                                <el-form-item label="合同附件：" prop="file_list">
                                    <el-upload class="upload-demo" name="contractFile"
                                    action="api/common/upload-contract"
                                    :headers="headers"
                                    :on-error="uploadError" :on-success="uploadSuccess"
                                    :on-preview="handlePreview"
                                    :on-remove="handleRemove" :file-list="contractForm.file_list"
                                    :before-upload="beforeUpload" list-type="text" multiple>
                                        <el-button type="primary">点击上传</el-button>
                                        <div slot="tip" class="el-upload__tip">上传pdf,docx,doc格式文档或JPG,JPEG,PNG图片,单个文件最大支持50MB,上传请耐心等待</div>
                                    </el-upload>
                                </el-form-item>
                                <!--合同附件-->
                                <el-form-item v-if="$route.path=='/order/revise'" label="修订理由：" class="inline-item" prop="reason">
                                    <el-input class="inline-input" type="textarea" :rows="2" v-model="contractForm.reason"></el-input>
                                </el-form-item>
                            </div>
                            <el-form-item>
                                <el-button type="primary" @click="submitContract('contractForm')" :disabled="contractForm.is_submit || uploadCount > 0">提交</el-button>
                            </el-form-item>
                        </el-form>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
    </div>
</template>
<style scoped>
.label-content {
   text-align: right;
   font-size: small;
}
.row-bg {
    padding: 0 0;
}
</style>
<script>
    import ProductTable from "~/views/order/table.vue";
    import InvoiceTable from "~/views/order/invoiceTable.vue";
    import InvoiceShowTable from "~/views/order/invoiceShowTable.vue";
    import ExpressTable from "~/views/order/expressTable.vue";
    import ExpressShowTable from "~/views/order/expressShowTable.vue";
    import PayPlanTable from "~/views/order/payPlanTable.vue";
    import ProductDialog from "~/views/order/productDialog.vue";
    import OrderService from "~/services/order";
    import CustomerSelect from "~/widgets/CustomerSelect.vue";
    import OrderUserSelect from "~/widgets/OrderUserSelect.vue";
    import Config from "~/config/params";
    import CommonService from "~/services/common";
    import CustomerService from "~/services/customer";

    export default {
        components: {
            ProductTable,
            ProductDialog,
            PayPlanTable,
            InvoiceTable,
            InvoiceShowTable,
            ExpressTable,
            ExpressShowTable,
            CustomerSelect,
            OrderUserSelect,
            Config
        },
        computed: {
            pfm_total_amount() {
                return _.reduce(this.financeForm.user, (memo, item) => {
                    return memo + (Number(item.pfm_amount) || 0)
                }, 0)
            },
            renew_total_amount() {
                return _.reduce(this.financeForm.user, (memo, item) => {
                    return memo + (Number(item.renew_amount) || 0)
                }, 0)
            },
            finish_total_amount() {
                return _.reduce(this.financeForm.user, (memo, item) => {
                    return memo + (Number(item.finish_amount) || 0)
                }, 0)
            },
            //续费目标订单合同开始时间
            target_contract_start_time(){
                let contract_start_time = '';
                if(this.financeForm.target_id){
                    this.target_orders.forEach(item => {
                        if(item.id == this.financeForm.target_id){
                            contract_start_time = item.contract_start_time;
                        }
                    });
                }
                return contract_start_time;
            },
            //续费目标订单合同结束时间
            target_contract_end_time(){
                let contract_end_time = '';
                if(this.financeForm.target_id){
                    this.target_orders.forEach(item => {
                        if(item.id == this.financeForm.target_id){
                            contract_end_time = item.contract_end_time;
                        }
                    });
                }
                return contract_end_time;
            },
        },
        watch: {
            'financeForm.type': (val) => {
                global.order_type = val;
            }
        },
        data() {
            /**@description 验证回款计划 */
            var validateRepayPlan = (rule, value, callback) => {

                if (this.financeForm.plan_pay.length == 0) {
                    callback(new Error("请填写回款计划"))
                }
                let pay_log_sum = 0;
                let is_money = /^[0-9]+$|^[0-9]+[\.]?[0-9]{0,2}$/;
                this.financeForm.plan_pay.forEach(item => {
                    if (item.plan_at == '' || typeof(item.plan_at) == "undefined") {
                        callback(new Error("请填写回款日期"))
                    }
                    if (!is_money.test(item.plan_amount)) {
                        callback(new Error("金额只支持录入最大保留两位小数的有效数字"));
                    }
                    if (item.plan_amount > 99999999) {
                        callback(new Error('还在输，看来这是个大客户呀！'));
                    }
                    if (item.plan_amount < 0) {
                        callback(new Error("计划回款金额必须为正数"))
                    }
                    pay_log_sum += parseFloat(item.plan_amount);
                    if ((Math.round(pay_log_sum * 100) / 100) > this.financeForm.total_amount) {
                        callback(new Error("计划回款金额不能大于销售额"));
                    }
                });
                
                if (pay_log_sum && pay_log_sum < this.financeForm.total_amount) {
                    callback(new Error("计划回款金额之和必须等于销售额"));
                }
                if ((pay_log_sum  == 0 &&  this.financeForm.total_amount !=0) || pay_log_sum < this.financeForm.total_amount) {
                    callback(new Error("计划回款金额之和必须等于销售额"+ this.financeForm.total_amount));
                }

                callback();
            };

            /**@description 验证发票信息 */
            var validateInvoice = (rule, value, callback) => {
                /**@description 验证逻辑 */
                this.financeForm.invoice.forEach(item => {
                    if (item.title == '' || typeof(item.title) == "undefined") {
                        callback(new Error("请填写发票抬头"));
                    }
                    if (item.taxpayer_id == '' || typeof(item.taxpayer_id) == "undefined") {
                        return callback(new Error("请输入纳税人识别号"));
                    } else {
                        const taxpayerLen = String(item.taxpayer_id).trim().length;
                        if (taxpayerLen !== 15 && taxpayerLen !== 18 && taxpayerLen !== 20) {
                            return callback(new Error("纳税人识别号长度不符合要求，请检查后重新输入"));
                        }
                    }
                });
                callback();
            };
            var validateRenewAmount = (rule, value, callback) => {
                if (this.renew_total_amount > this.financeForm.total_amount) {
                    callback(new Error("总续费金额不能大于销售额"));
                }
                // 如果验证通过，手动触发 pfm_total_amount 的验证
                this.$refs.financeForm.validateField('pfm_total_amount');
                callback();
            };
            var validateCorp = (rule, value, callback) => {
                const user = this.financeForm.user.find(function (item) {
                    return item.is_cooperator == 0;
                });
                if (this.financeForm.user.length == 0 || !user || !user.user_id){
                    callback(new Error("请添加订单负责人！"));
                }
                if (this.financeForm.user.length > 0) {
                    if (this.pfm_total_amount > this.financeForm.total_amount) {
                        callback(new Error("总业绩金额不能大于销售额"));
                    }
                    if (this.renew_total_amount > this.financeForm.total_amount) {
                        callback(new Error("总续费金额不能大于销售额"));
                    }
                    if (this.finish_total_amount > this.financeForm.to_renew_amount) {
                        callback(new Error("所有”续费完成额“之和必须小于等于“应续金额”"));
                    }
                }
                // 如果验证通过，手动触发 pfm_total_amount 的验证
                this.$refs.financeForm.validateField('pfm_total_amount');
                callback();
            };
            
            var validatePfmTotalAmount = (rule, value, callback) => {
                /**
                * 总续费金额
                */
                if ((this.renew_total_amount + this.pfm_total_amount) > this.financeForm.total_amount) {
                    callback(new Error("总业绩金额+总续费金额不能大于销售额"));
                }
                callback();
            };

            var validateFinishTotalAmount = (rule, value, callback) => {
                /**
                * 总续费完成金额
                */
                if (this.finish_total_amount > this.financeForm.to_renew_amount) {
                    callback(new Error("所有”续费完成额“之和必须小于等于“应续金额”"));
                }
                callback();
            };
return {
  isshowinvoice:false,
  activeName: 'finance',
  invoiceForm: null,
  expressForm: null,
  loading: false,
  uploadCount: 0,
  customer_contracts: [],//客户联系人列表
                target_orders: [],//续费目标订单列表
                scenary: 'create_order_use',
                order_no: 0,
                total_amount: 0,//产品总金额=成交金额
                customer_id: '',
                financeForm: {
                    sign_mode: 0,
                    source: '',
                    finance_audit:'',
                    customer_name: '',
                    type: 1,
                    contact_name: '',//联系人
                    contact_mobile: '',//联系人手机号码
                    customer_id: '',
                    products: [],//开通产品列表
                    open_xd: [],
                    is_submit: false,
                    id: this.order_id,
                    sale: this.$store.getters.userId,//销售人，为什么要加上这个，而不是把当前登录用户当做销售人，比如有些管理层级别的大佬开单叫助理入单，而助理并非是销售人。
                    sale_name: this.$store.getters.name,//销售人，为什么要加上这个，而不是把当前登录用户当做销售人，比如有些管理层级别的大佬开单叫助理入单，而助理并非是销售人。
                    customer_sign_man: '',//客户签约人
                    customer_mobile: '',//客户签约人手机号
                    user: [
                        {
                            "no": 1,
                            'id': 0,
                            "user_id": this.$store.getters.userId,
                            "name": this.$store.getters.name,
                            'pfm_amount': 0,
                            'renew_amount': 0,
                            'finish_amount': 0,
                            'is_cooperator': 0,
                            'is_cooperator_str': '负责人'
                        }
                    ],//订单负责人协作人
                    contract_time: [new Date(Date.now()), new Date(Date.now() + 24 * 3600 * 10 * 1000)],//合同时间
                    total_amount: 0,//总金额
                    refund_amount: 0,//退款金额
                    plan_pay: [], //回款计划
                    invoice: [],//发票信息
                    express: [],//快递信息
                    memo: '', //备注信息
                    reason: '', //修订理由
                    class_num: '',
                    teacher_num: '',
                    target_id: '',
                    to_renew_amount: 0,
                    revise_type: '',
                    file_list: [],
                },
                contractForm: {
                    order_id: '',
                    contract_number: '',
                    is_submit: false,
                    id: this.order_id,
                    file_list: [],//合同文件
                    reason: '',//修订理由
                    is_auto_contract_number: false //标记合同编号是否是系统自动填入的
                },
                financeRules: {
                    customer_id:  [
                        {required: true, message: '请选择开单客户', trigger: 'blur'},
                    ],
                    type: [
                        {required: true, message: '请选择订单类型', trigger: 'blur'},
                    ],
                    sign_mode: [
                        {required: true, message: '请选择签单模式', trigger: 'blur'},
                    ],
                    contact_name: [
                        {required: true, message: '请选择客户联系人', trigger: 'blur'},
                    ],
                    sale: [
                        {required: true, message: '请选择订单负责人', trigger: 'blur'},
                    ],
                    products: [
                        {required: true, message: '请选择产品', trigger: 'blur'}
                    ],
                    reason: [
                        {required: true, message: '请输入修订理由', trigger: 'blur'},
                    ],
                    source: [
                        {required: true, message: '请选择成交来源', trigger: 'blur'},
                    ],
                    open_xd: [
                        {required: true, message: '请选择学段', trigger: 'blur'},
                    ],
                    class_num: [
                        {required: true, message: '请输入班级数', trigger: 'blur'},
                    ],
                    teacher_num: [
                        {required: true, message: '请输入教师数', trigger: 'blur'},
                    ],
                    total_amount: [
                        {required: true, message: '请输入销售额', trigger: 'blur'},
                    ],
                    refund_amount: [
                        {required: true, message: '请输入销售额', trigger: 'blur'},
                    ],
                    plan_pay: [
                        {required: true, validator: validateRepayPlan, trigger: 'blur'}
                    ],
                    user: [
                        {required: true, validator: validateCorp, trigger: 'change'}
                    ],
                    invoice: [
                        {validator: validateInvoice, trigger: 'blur'}
                    ],
                    renew_total_amount: [
                        {validator: validateRenewAmount, trigger: 'change'}
                    ],
                    pfm_total_amount: [
                        {validator: validatePfmTotalAmount, trigger: 'change'}
                    ],
                    finish_total_amount: [
                        {validator: validateFinishTotalAmount, trigger: 'change'}
                    ],
                    target_id: [
                        {required: true, message: '请选择续约目标单', trigger: 'blur'},
                    ],
                    to_renew_amount: [
                        {required: true, message: '请输入应续金额', trigger: 'blur'},
                        {validator: validateFinishTotalAmount, trigger: 'change'}
                    ]
                },
                contractRules: {
                    reason: [
                        {required: true, message: '请输入修订理由', trigger: 'blur'},
                    ],
                    contract_time: [
                        {required: true, message: '请填写合同开始结束时间', trigger: 'blur'},
                    ],
                    contract_number: [
                        {required: true, message: '请填写合同编号', trigger: 'blur'},
                    ],
                    file_list: [
                        {required: true, message: '请上传合同附件', trigger: 'blur'},
                    ]
                },
                productChecked: [],
                productList: [],
                dialogExpressVisible: false,
                dialogInvoiceVisible: false,
                config: [],
                headers: {
                    "access-token": this.$store.getters.token
                },
                customer_name: this.$route.query['name'],  //客户名称
                onlyShow: this.$route.query['onlyShow'],  //是否可搜索
                newAmount: 0,

                groupedProducts: [],
                times: [],

                user_loading: false,
            }
        },
        created() {
            this.financeForm.revise_type = this.$route.query["revise_type"] ? this.$route.query["revise_type"] : ''
            global.customer_id = '';
            global.order_type = 1;
            global.periods = [];
            this.config = Config;
            if (this.$route.query['customer_id']) {
                this.customer_id = this.$route.query['customer_id'];
                this.financeForm.customer_id = this.customer_id
                this.getCustomerInfo();
                this.getCustomerContracts();
                this.getTargetOrder();
            }
            /**
             * 编辑订单或者修订订单以及续约订单
             * @type {string}
             */
            let orderId = this.$route.query["id"];
            if (orderId) {
                this.$nextTick(function () {
                    this.render(orderId, this.$route.path == '/order/renew' ? orderId : 0, this.$route.path == '/order/renew');
                })
                this.activeName = this.$route.query["type"] ? this.$route.query["type"] : 'finance';
                this.id = orderId;
            }
        },
        mounted() {
            this.loading = true;
            CommonService.getProducts({
                status: 1,
                is_deleted: 0,
                fields: 'id,name,price,code,allow_config,memo,type_id,type_name',
                expand: 'start_at,end_at,disabled',
                scenary: 'show-all'
            }).then(res => {
                this.productList = res.data;
                this.changeType(this.financeForm.type);
                this.loading = false;
                this.setGroupedProducts();
            });
        },
        methods: {
            getCustomerInfo() {
                CustomerService.getInfo(this.customer_id).then(res => {
                    if (res.code == 0) {
                        this.customer_name = res.data['name'];
                        this.financeForm.customer_name = res.data['name'];
                        this.loading = false;
                    }
                })
            },

            /**@description 产品配置校验 */
            handleDialogConfigureShow(config) {
                this.$refs['financeForm'].validateField('products', (valid) => {
                    if (valid) {
                        console.log(valid);
                    } else {
                        console.log(valid);
                        return false;
                    }
                });
            },
            handleMoney() {
                let all_price = 0;
                let all_refund_amount = 0;
                this.financeForm.products.forEach(item => {
                    let is_money = /^[0-9]+$|^[0-9]+[\.]?[0-9]{0,2}$/;
                    let old_price = (Math.round(parseFloat(item.old_price) * 100) / 100);
                    let price = (Math.round(parseFloat(item.price) * 100) / 100);
                    if (price < 0 || !is_money.test(price)) {
                        this.$message({
                            message: item.product_name + " 的价格填写错误, 只支持录入大于0且最大保留两位小数的数字",
                            type: "error"
                        });
                    }
                    if(this.financeForm.revise_type == 'refund'){
                        if(old_price < price){
                            this.$message({
                                message: item.product_name + " 的价格填写错误, 退款修订只能下调产品价格",
                                type: "error"
                            });
                        }
                        item.refund_amount = Math.round((old_price - price) * 100) / 100;
                        all_refund_amount += item.refund_amount;
                    }
                    return all_price += price;
                });
                // console.log('handleMoney:', all_price, all_refund_amount);
                this.financeForm.refund_amount = (Math.round(all_refund_amount * 100) / 100);
                this.financeForm.total_amount = (Math.round(all_price * 100) / 100);
                this.handleDialogConfigureShow();
            },

            changeType(type){
                if(type != this.config.TYPE_RENEW){
                    this.financeForm.target_id = '';
                }
                this.productList = this.productList.map(item=>{
                    //if(item.id == 95) return item;
                    item.start_at = type == 1 ? (new Date(new Date(new Date().toLocaleDateString()).getTime())).getTime() : '';
                    item.end_at = type == 1 ? (new Date(new Date(new Date().toLocaleDateString()).getTime())).getTime()+ 86400*10*1000 : '';
                    item.start_at_fomat = type == 1 ? (new Date(item.start_at).toLocaleDateString()).replace(/\//g,'-') : '';
                    item.end_at_fomat = type == 1 ? (new Date(item.end_at).toLocaleDateString()).replace(/\//g,'-') : '';
                    item.effect_at = type == 1 ? [item.start_at_fomat, item.end_at_fomat] : [];
                    return item;
                })
            },

            changeSignMode(sign_mode){
                console.log('changeSignMode: ', sign_mode);
            },

            /**
             * tab 切换
             * @description 产品信息提交后，基本信息才可以被解锁，然后进行编辑提交，基本信息提交后，合同附件才可以被解锁提交
             */
            switchTab(activeName, oldActiveName) {
                if(activeName=='order') return true;
                if (activeName == 'contract') {
                    if (this.Acs('/order/supervisorFinance')) return true;
                    if (this.Acs('/order/supervisorContract')) return true;
                    if (!this.financeForm.is_submit) {
                        this.$message({
                            message: "请先提交基本信息",
                            type: "error"
                        });
                        this.activeName = oldActiveName;
                        return false;
                    }
                    if(!this.financeForm.finance_audit){
                        this.$message({
                            message: "基本信息审核未通过,不允许提交其他信息",
                            type: "error"
                        });
                        this.activeName = oldActiveName;
                        return false;
                    }
                }
            },
            /**@description 回款计划*/
            addPayPlan() {
                let date = new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate();
                this.financeForm.plan_pay.push({
                    "no": this.financeForm.plan_pay.length + 1,
                    "plan_at": date,
                });
            },
            handleDeletePay(no) {
                this.financeForm.plan_pay = this.financeForm.plan_pay.filter(function (item) {
                    return item.no != no;
                });

                this.$refs.financeForm.validateField("plan_pay", function(errmsg) {
                    // console.log('++++++++++', errmsg);
                });

            },
            /** 回款计划end*/

            /**添加协作人*/
            addCorp() {
                this.financeForm.user.push({
                    "no": this.financeForm.user.length + 1,
                    'id': 0,
                    "user_id": "",
                    "name": "",
                    'pfm_amount': 0,
                    'renew_amount': 0,
                    'finish_amount': 0,
                    'is_cooperator': 1,
                    'is_cooperator_str': '协作人'
                });
            },

            //客户名称远程搜索组件赋值
            CustomerHandleChange(object) {
                global.customer_id = object.label;
                this.customer_id = object.label;
                if (typeof this.customer_id == "undefined") return false;
                this.financeForm.customer_id = object.label;
                this.getCustomerInfo();
                this.getCustomerContracts();
                this.getTargetOrder();
                this.productCheckeds();
            },

            /**@description 添加快递信息 */
            dialogExpressTable() {
                this.expressForm = null;
                if (!this.customer_id) {
                    this.dialogExpressVisible = true;
                    return;
                }

                CustomerService.getLastAddress(this.customer_id).then(res => {
                    if (res.code == 0 && res.data.id) {
                        let express = res.data;
                        this.expressForm = {
                            name: express.name,
                            mobile: express.mobile,
                            province_id: express.province_id,
                            city_id: express.city_id,
                            district: express.district,
                            address: express.address,
                            express_company: express.express_company,
                            memo: express.memo,
                        };
                    }
                    this.dialogExpressVisible = true;
                }).catch(err => {
                    this.dialogExpressVisible = true;
                })

                return true;
            },

            addExpress(form) {
                if (form) {
                    if (!form.id) {
                        form.id = this.financeForm.express.length + 1;
                        this.financeForm.express.push(form);
                        this.$message({
                            message: "添加成功",
                            type: "success"
                        });
                    } else {
                        this.financeForm.express = _.map(this.financeForm.express, item => {
                            return item.id == form.id ? form : item;
                        });
                        this.$message({
                            message: "编辑成功",
                            type: "success"
                        });
                    }
                }
                this.dialogExpressVisible = false;
            },

            handleDeleteExpress(id) {
                this.financeForm.express = this.financeForm.express.filter(function (item) {
                    return item.id != id;
                });
            },

            handleShowExpress(id) {
                this.dialogExpressVisible = true;
                this.expressForm = this.financeForm.express.find(function (item) {
                    return item.id == id;
                });
            },

            /** @description 添加发票信息*/
            dialogInvoiceTable() {

                this.invoiceForm = null;
                if (!this.customer_id) {
                    this.dialogInvoiceVisible = true;
                    return;
                }

                CustomerService.getLastInvoice(this.customer_id).then(res => {
                    if (res.code == 0 && res.data) {

                        let invoice = res.data;
                        this.invoiceForm = {
                            type: invoice.type,
                            title: invoice.title,
                            content: parseInt(invoice.content),
                            total_amount: invoice.total_amount,
                            input_at: invoice.input_at,
                            taxpayer_id: invoice.taxpayer_id,
                            bank_name: invoice.bank_name,
                            account: invoice.account,
                            mobile: invoice.mobile,
                            email: invoice.email,
                            address: invoice.address,
                            file_list: invoice.file_list,
                            attachment_ids: '',
                            memo: invoice.content_memo
                        };
                    }

                    this.dialogInvoiceVisible = true;
                    return;
                }).catch(err => {
                    this.dialogInvoiceVisible = true;
                })
            },

            addInvoice(form) {
                if (form) {
                    console.log('addInvoice:', form, !form.id);
                    if (!form.id) {
                      //续约的不能带有原先发票
                        if(this.$route.path == '/order/renew' && this.isshowinvoice==false){
                          this.financeForm.invoice = [];
                        }
                        form.id = this.financeForm.invoice.length + 1;
                        this.financeForm.invoice.push(form);
                        this.isshowinvoice = true
                        console.log('添加成功:', this.financeForm.invoice);
                        this.$message({
                            message: "添加成功",
                            type: "success"
                        });
                    }
                    else {
                        this.financeForm.invoice = _.map(this.financeForm.invoice, item => {
                            return item.id == form.id ? form : item;
                        });
                        console.log('编辑成功:', this.financeForm.invoice);
                        this.$message({
                            message: "编辑成功",
                            type: "success"
                        });
                    }
                }
                this.dialogInvoiceVisible = false;
            },

            handleEditInvoice(id) {
                console.log('handleEditInvoice:', id);
                this.dialogInvoiceVisible = true;
                this.invoiceForm = this.financeForm.invoice.find(function (item) {
                    return item.id == id;
                });
            },

            handleDeleteInvoice(id) {
                this.financeForm.invoice = this.financeForm.invoice.filter(function (item) {
                    return item.id != id;
                });
            },

            /** @description 合同附件*/
            handleRemove(file, fileList) {
                if (Array.isArray(fileList)) {
                    this.contractForm.file_list = this.getUploadedFileList(fileList);
                    return;
                }
                if (file) {
                    this.contractForm.file_list = this.getUploadedFileList(this.contractForm.file_list).filter(item => item.uid !== file.uid && item.id !== file.id);
                }
            },

            handlePreview(file) {
                window.open(file.url);
            },

            getUploadedFileList(fileList) {
                const list = Array.isArray(fileList) ? fileList : [];
                return list.map(file => this.normalizeUploadedFile(file)).filter(file => file && file.id);
            },

            getUploadedFileId(file) {
                if (!file) {
                    return null;
                }
                const data = file.response && file.response.data ? file.response.data : file;
                const id = Number(data && data.id);
                return Number.isInteger(id) && id > 0 ? id : null;
            },

            normalizeUploadedFile(file) {
                if (!file || file.status === 'fail' || file.status === 'uploading' || file.status === 'ready') {
                    return null;
                }
                if (file.response && file.response.code > 0) {
                    return null;
                }
                const data = file.response && file.response.data ? file.response.data : file;
                const id = this.getUploadedFileId(file);
                if (!id) {
                    return null;
                }
                return {
                    name: data.file_name || data.name || file.name,
                    url: data.file_path || data.url || file.url,
                    id,
                    uid: file.uid || id,
                    status: file.status || 'success'
                };
            },

            appendUploadedFile(currentList, response, file) {
                const uploaded = this.normalizeUploadedFile(Object.assign({}, file, {
                    response,
                    status: 'success'
                }));
                const next = this.getUploadedFileList(currentList);
                if (!uploaded) {
                    return next;
                }
                return next.filter(item => item.id !== uploaded.id && item.uid !== uploaded.uid).concat(uploaded);
            },

            finishUpload() {
                this.uploadCount = Math.max(this.uploadCount - 1, 0);
            },

            uploadSuccess(response, file, fileList) {
                if (response.code > 0) {
                    this.$message({
                        message: response.msg,
                        type: 'error'
                    });
                    const list = Array.isArray(fileList) ? fileList.filter(item => item.uid !== file.uid) : this.contractForm.file_list;
                    this.contractForm.file_list = this.getUploadedFileList(list);
                } else {
                    this.contractForm.file_list = this.appendUploadedFile(this.contractForm.file_list, response, file);
                }
                this.finishUpload();
            },

            uploadFinanceSuccess(response, file, fileList) {
                if (response.code > 0) {
                    this.$message({
                        message: response.msg,
                        type: 'error'
                    });
                    const list = Array.isArray(fileList) ? fileList.filter(item => item.uid !== file.uid) : this.financeForm.file_list;
                    this.$set(this.financeForm, 'file_list', this.getUploadedFileList(list));
                } else {
                    this.$set(this.financeForm, 'file_list', this.appendUploadedFile(this.financeForm.file_list, response, file));
                }
                this.finishUpload();
            },

            handleFinanceRemove(file, fileList) {
                if (Array.isArray(fileList)) {
                    this.financeForm.file_list = this.getUploadedFileList(fileList);
                    return;
                }
                if (file) {
                    this.financeForm.file_list = this.getUploadedFileList(this.financeForm.file_list).filter(item => item.uid !== file.uid && item.id !== file.id);
                }
            },

            uploadError(err, file, fileList) {
                console.log('===');
                this.finishUpload();
            },

beforeUpload(file) {
  let dot = file.name.lastIndexOf(".");
  let extension = file.name.substring(dot).toLowerCase();
  let filesize = file.size / 1024 / 1024 > 50;
  let type = ['.pdf', '.docx', '.doc', '.jpg', '.jpeg', '.png'];

  if (!type.includes(extension)) {
    this.$message({
      message: '上传格式不允许,只允许上传pdf,docx,doc,jpg,jpeg,png格式文件',
      type: 'error'
    });
    return false;
  }
  if (filesize) {
    this.$message({
      message: '上传文件大小不能超过50M',
      type: 'error'
    });
    return false;
  }
  this.uploadCount++;
},

            /**@description 提交处理 */
            submitFinance(formName) {
                this.$refs['commonForm'].validate((common_valid) => {
                    if(common_valid){
                        this.$refs[formName].validate((valid) => {
                            if (valid) {
                                if(this.productChecked.every(item => item == 11)){
                                    this.$message({
                                        message: '不支持单独开通数字化校园',
                                        type: 'error'
                                    });
                                    return false;
                                }
                                this.finance();
                            } else {
                                console.log('error submit!!');
                            }
                        });
                    }
                });
            },

            /**@description 提交处理 */
            submitContract(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.contract();
                    } else {
                        console.log('error submit!!');
                    }
                });
            },

            
            finance() {
                let is_money = /^[0-9]+$|^[0-9]+[\.]?[0-9]{0,2}$/;
                if (this.financeForm.total_amount < 0 || !is_money.test(this.financeForm.total_amount)) {
                    this.$message({
                        message: '销售额只支持最大保留两位小数的有效数字, 请调整产品价格',
                        type: 'error'
                    });
                    return;
                }

                switch (this.$route.path) {
                    case '/order/revise':
                        this.financeRevise();
                        break;
                    case '/order/edit':
                        this.financeUpdate();
                        break;
                    default:
                        this.financeAudit();
                        break;
                }
            },

            product() {
                switch (this.$route.path) {
                    case '/order/revise':
                        this.productRevise();
                        break;
                    case '/order/renew':
                        this.productRenew();
                        break;
                    case '/order/edit':
                        this.productUpdate();
                        break;
                    default:
                        this.productCreate();
                        break;
                }
            },

            contract() {
                switch (this.$route.path) {
                    case '/order/revise':
                        this.contractRevise();
                        break;
                    case '/order/edit':
                        this.contractUpdate();
                        break;
                    default:
                        this.contractCreate();
                        break;
                }
            },

            /**基本修订*/
            financeRevise() {
                this.financeForm.is_submit = true;
                OrderService.reviseFinance(this.financeForm).then(res => {
                    if (res.code == 0) {
                        this.order_id = res.data.order_id;
                        if (res.msg != 'success') {
                            this.alert_go(res.msg);
                            return false;
                        }
                        this.$message({
                            message: '更新基本信息成功',
                            type: 'success'
                        });
                        let path = "/order/view?id=" + res.data.order_id + "&flow_type=2&type=3&revise_id=" + res.data.id;
                        this.$router.push({
                            path: path,
                            query: {
                                referer: this.$route.path
                            }
                        });
                    } else {
                        this.financeForm.is_submit = false;
                    }
                }).catch(err => {
                    this.$message({
                            message: '更新失败',
                            type: 'error'
                        });
                    console.error(err)
                    this.financeForm.is_submit = false;
                });
            },

            /**
             * 续约产品
             * */
            productRenew() {
                OrderService.createProduct(this.financeForm).then(res => {
                    if (res.code == 0) {
                        this.order_id = res.data.id;
                        this.financeForm.is_submit = true;
                        this.alert_go('产品续约成功');
                    } else {
                        this.financeForm.is_submit = false;
                    }
                });
            },

            alert_go(msg) {
                this.$message({
                    message: msg,
                    type: 'success'
                });
                this.$router.push({
                    path: '/order/view?id=' + this.order_id
                });
            },

            productUpdate() {
                this.financeForm.is_submit = true;
                OrderService.updateProduct(this.financeForm).then(res => {
                    if (res.code == 0) {
                        this.order_id = res.data.id;
                        this.alert_go('更新产品信息成功');
                        //如果是试用订单就不需要填写基本合同附件，直接跳转到之前的页面
                        if (this.financeForm.type == this.config.TYPE_TRY_OUT) {
                            this.$refs['financeForm'].resetFields();
                            this.$router.push({path: this.$route.query['referer']});
                        }
                    }
                    this.financeForm.is_submit = false;
                });
            },

            /**
             * 修订产品
             * */
            productRevise() {
                OrderService.reviseProduct(this.financeForm).then(res => {
                    if (res.code == 0) {
                        this.order_id = res.data.order_id;
                        this.financeForm.is_submit = true;
                        if (res.msg != 'success') {
                            this.alert_go(res.msg);
                            return false;
                        }
                        this.$message({
                            message: '修订产品信息成功',
                            type: 'success'
                        });
                        let path = "/order/view?id=" + res.data.order_id + "&flow_type=1&type=3&revise_id=" + res.data.id;
                        this.$router.push({
                            path: path,
                            query: {
                                referer: this.$route.path
                            }
                        });
                        //如果是试用订单就不需要填写基本合同附件，直接跳转到之前的页面
                        if (this.financeForm.type == this.config.TYPE_TRY_OUT) {
                            this.$refs['financeForm'].resetFields();
                            this.$router.push({path: this.$route.query['referer']});
                        }
                    } else {
                        this.financeForm.is_submit = false;
                    }
                });
            },

            /**@description 创建产品信息 */
            productCreate() {
                OrderService.createProduct(this.financeForm).then(res => {
                    if (res.code == 0) {
                        this.order_id = res.data.id;
                        this.alert_go('创建产品信息成功');
                    } else {
                        this.financeForm.is_submit = false;
                    }
                });
            },

            /**@description 创建财务信息*/
            financeAudit() {
                this.financeForm.is_submit = true;
                if(this.financeForm.type ==1) { //试用订单需要进行审核提示
                    let product_ids = '';
                    let products = [];
                    this.financeForm.products.forEach(function (v) {
                        product_ids +=v.id+',';
                        if(v.id){
                            products.push({
                                id: v.id,
                                start_at: v.start_at,
                                end_at: v.end_at,
                            });
                        }
                    })
                    
                    CommonService.tipAudit({
                        customer_id : this.financeForm.customer_id,
                        user_id : this.financeForm.sale,
                        product_ids : product_ids,
                        products: products
                    }).then(res => {
                        if(res.code==0) {
                            if(res.data != null){
                                //弹框提示
                                this.$confirm("该试用订单提交后需要【"+res.data+"】进行审核，确定提交吗？", "温馨提示", {type: "warning"}).then(ok => {
                                    this.financeCreate();
                                });
                            }else{
                                this.financeCreate();
                            }
                        }
                        this.financeForm.is_submit = false;
                    }).catch(err => {
                        console.error(err);
                        this.financeForm.is_submit = false;
                    });
                }else{
                    this.financeCreate();
                }
            },

            financeCreate(){
                this.financeForm.is_submit = true;
                OrderService.createFinance(this.financeForm).then(res => {
                    if (res.code == 0) {
                        this.$message({
                            message: '创建基本信息成功',
                            type: 'success'
                        });
                        this.$router.push({
                            path: '/order/view?id=' + res.data.id + '&tab=' + this.activeName
                        });
                    } else {
                        this.financeForm.is_submit = false;
                    }
                }).catch(err => {
                    this.financeForm.is_submit = false;
                    console.error(err);
                });
            },

            financeUpdate() {
                this.financeForm.is_submit = true;
                OrderService.updateFinance(this.financeForm).then(res => {
                    if (res.code == 0) {
                        this.$message({
                            message: '更新基本信息成功',
                            type: 'success'
                        });
                        this.$router.push({
                            path: '/order/view?id=' + res.data.id + '&tab=' + this.activeName
                        });
                    } else {
                        this.financeForm.is_submit = false;
                    }
                });
            },

            /**@description 更新合同附件*/
            contractUpdate() {
                this.contractForm.is_submit = true;
                OrderService.updateContract(this.contractForm).then(res => {
                    if (res.code == 0) {
                        this.$message({
                            message: '更新合同附件成功',
                            type: 'success'
                        });
                        this.$router.push({
                            path: '/order/view?id=' + res.data.id + '&tab=' + this.activeName
                        });
                    } else {
                        this.contractForm.is_submit = false;
                    }
                });
            },

            /**@description 创建合同附件 */
            contractCreate() {
                this.contractForm.is_submit = true;
                OrderService.createContract(this.contractForm).then(res => {
                    if (res.code == 0) {
                        this.$message({
                            message: '创建合同附件成功',
                            type: 'success'
                        });
                        this.$router.push({
                            path: '/order/view?id=' + res.data.id + '&tab=' + this.activeName
                        });
                    } else {
                        this.contractForm.is_submit = false;
                    }
                });
            },
            
            clear() {
                OrderService.clear(this.contractForm.order_id).then(res => {
                    this.contractForm.contract_number = '';
                })
            },

            /**合同修订*/
            contractRevise() {
                this.contractForm.is_submit = true;
                OrderService.reviseContract(this.contractForm).then(res => {
                    if (res.code == 0) {
                        this.order_id = res.data.order_id;
                        if (res.msg != 'success') {
                            this.alert_go(res.msg);
                            return false;
                        }
                        this.$message({
                            message: '更新合同附件成功',
                            type: 'success'
                        });
                        let path = "/order/view?id=" + res.data.order_id + "&flow_type=3&type=3&revise_id=" + res.data.id;
                        this.$router.push({
                            path: path,
                            query: {
                                referer: this.$route.path
                            }
                        });
                    }
                    this.contractForm.is_submit = false;
                });
            },

            /**@description
             * 获取学校联系人列表
             */
            getCustomerContracts() {
                if (!this.financeForm.customer_id) return false;
                CommonService.getContacts({
                    customer_id: this.financeForm.customer_id,
                    scenario: 'get_all'
                }).then(res => {
                    if (!res.code) {
                        this.customer_contracts = res.data;
                    }
                })
            },

            /**
             * 用于获取续约目标列表
             */
             getTargetOrder() {
                if (!this.financeForm.customer_id) return false;
                CommonService.getTargetOrder({customer_id: this.financeForm.customer_id, order_id: this.$route.path == '/order/revise' ? this.financeForm.id : ''}).then(res => {
                    if (!res.code) {
                        this.target_orders = res.data;
                        this.setToRenewAmount();
                    }
                })
            },

            //客户签约人
            selectCustomerSign($event) {
                let contact = this.customer_contracts.find(item => {
                    if (item.id == $event) {
                        return item;
                    }
                });
                if (contact) {
                    this.financeForm.contact_id = contact.id;
                    this.financeForm.contact_name = contact.name;
                    this.financeForm.customer_sign_man = contact.name;
                    this.financeForm.customer_mobile = this.financeForm.contact_mobile =  contact.mobile || contact.phone_number;
                }
            },

            //续约目标单
            selectTarget(order_id) {
                // console.log('续约目标单:', order_id);
                this.render(order_id, order_id, true);
            },
            
            /**@desc 产品选择 */
            productCheckeds() {
                /**
                 * 先有客户再有产品
                 */
                if (!this.customer_id) {
                    this.productChecked = [];
                    this.$message({
                        message: '请填写客户名称 ，再进行产品选择',
                        type: 'warning'
                    });
                    return false;
                }

                //旧版阅卷→新版阅卷 旧版排课→新版排课 旧版学业评价→新版学业评价
                this.setProductIds();

                this.financeForm.customer_id = this.customer_id;
                //删除产品
                this.financeForm.products = this.financeForm.products.filter(item => {
                    return this.productChecked.includes(item.id);
                });
                //添加产品
                let old_product_ids = this.financeForm.products.map(item => item.id);
                let add_product_ids = this.productChecked.filter(product_id => !old_product_ids.includes(product_id));
                if(add_product_ids && add_product_ids.length > 0){
                    this.productList.filter(item => {
                        if(add_product_ids.includes(item.id)){
                            this.financeForm.products.push(item);
                        }
                    });
                }

                // 按 type_id 升序排序
                this.financeForm.products.sort((a, b) => {
                    const nameA = a.name.toUpperCase();
                    const nameB = b.name.toUpperCase();

                    // 将 "项目（软件）" 排到数组开头
                    if (nameA === '项目（软件）') {
                        return -1;
                    } else if (nameB === '项目（软件）') {
                        return 1;
                    }
                    // 保持原有顺序
                    return 0;
                });
                this.financeForm.products = this.financeForm.products.map(product => ({...product}));
                this.setDefaultSzxyData();
                this.handleMoney();
            },

            render(order_id, target_id = 0, is_target = false) {
                OrderService.getDetail(order_id).then(res => {
                    if (res.code != 0) {
                        this.$message({
                            message: '获取订单失败',
                            type: 'warning'
                        });
                        return false;
                    }
                    this.loading = false;
                    global.customer_id = res.data['customer_id'];
                    this.customer_id = res.data['customer_id'];
                    this.order_no = res.data['no'];
                    this.customer_name = res.data['customer_name'];
                    this.financeForm.customer_id = res.data['customer_id'];
                    this.financeForm = Object.assign(this.financeForm, res.data['finance']);
                    
                    // 处理财务信息的附件数据 - createAttachment
                    if (res.data['createAttachment'] && res.data['createAttachment'].length > 0) {
                        console.log('找到 createAttachment 附件数据:', res.data['createAttachment']);
                        this.financeForm.file_list = res.data['createAttachment'].map(file => {
                            return {
                                name: file.name || file.file_name || file.original_name,
                                url: file.url || file.file_path || file.path,
                                id: file.id,
                                uid: file.uid || file.id || Date.now() + Math.random(),
                                status: 'success'
                            };
                        });
                        console.log('处理后的财务附件数据:', this.financeForm.file_list);
                    } else {
                        console.log('没有找到 createAttachment 数据');
                        this.financeForm.file_list = [];
                    }
                    
                    console.log('render', order_id, target_id, is_target);
                    this.financeForm.id = this.financeForm.order_id = this.contractForm.id = this.contractForm.order_id = this.$route.query["id"] ? this.$route.query["id"] : res.data['id'];
                    if(!is_target) {
                        this.financeForm.type = res.data['type'];
                        this.financeForm.user = res.data.user;
                    }else{
                        this.financeForm.plan_pay = [];
                        this.financeForm.invoice = [];
                    }
                    // console.log('render:', order_id, target_id, is_target, this.financeForm);
                    this.financeForm.customer_name = res.data['customer_name'];
                    this.financeForm.contact_id = res.data['contact_id'];
                    this.financeForm.class_num = res.data['class_num'];
                    this.financeForm.teacher_num = res.data['teacher_num'];
                    this.financeForm.target_id = target_id > 0 ? target_id : res.data['target_id'];
                    this.financeForm.contact_name = this.financeForm.customer_sign_man = res.data['contact_name'];
                    this.financeForm.contact_mobile = this.financeForm.customer_mobile = res.data['contact_mobile'];
                    this.financeForm.sign_mode = res.data['sign_mode'];
                    this.financeForm.source = res.data['source'];
                    // if (res.data['finance']) {
                    //     this.financeForm.customer_sign_man = res.data['finance']['customer_sign_man'];
                    //     this.financeForm.customer_mobile = res.data['finance']['customer_mobile']
                    // }
                    this.financeForm.memo = res.data['memo'];
                    this.order = res.data;
                    
                    //是否可以进行编辑，防止提交之后在进行修改编辑操作
                    if (res.data['products']) this.financeForm.is_submit = true;
                    if (res.data['finance']) this.financeForm.is_submit = true;
                    this.contractForm.file_list = res.data['contracts'];
                    // 设置合同编号，并标记是否是系统自动填入的
                    if (res.data['contract_number']) {
                        this.contractForm.contract_number = res.data['contract_number'];
                        this.contractForm.is_auto_contract_number = true; // 从服务器获取的合同编号，标记为自动填入
                    } else {
                        this.contractForm.is_auto_contract_number = false; // 需要用户手动输入的合同编号
                    }
                    if (res.data['contracts'].length > 0 && res.data['contract_audit'] != 3) {
                        this.contractForm.is_submit = true;
                    }
                    
                    this.financeForm.is_submit = res.data['undo_product'] || res.data['undo_finance'] ? false : this.financeForm.is_submit;
                    this.contractForm.is_submit = res.data['undo_contract'] ? false : this.contractForm.is_submit;
                    
                    //判断是否有基本信息，合同附件，如果没有基本信息也是可以进行编辑新增的
                    if (!res.data['finance']) this.financeForm.is_submit = false;
                    if (!res.data['contracts'].length > 0) this.contractForm.is_submit = false;

                    //判断产品信息,基本信息，合同附件，审核是否通过，如果没有审核通过是可以进行编辑的
                    if (res.data['business_audit'] == 0 || res.data['finance_audit'] == 0) this.financeForm.is_submit = false;
                    if (res.data['contract_audit'] == 0) this.contractForm.is_submit = false;
                    if (res.data['finance_audit'] == 1) this.financeForm.finance_audit = true;
                    
                    this.financeForm.products = [];
                    let product_ids = [];
                    if(res.data['products']){
                        for(var i = 0; i < res.data['products'].length; i++){
                            let product = res.data['products'][i];
                            if(product_ids.includes(product.product_id)){
                                continue;
                            }
                            let new_product_id = product.product_id;
                            let new_product_name = product.name;
                            let new_product_code = product.product_code;
                            if(is_target){
                                if(product.product_id == 4){
                                    //校本2→校本3
                                    new_product_name = '校本资源库'
                                    new_product_id = 5;
                                    new_product_code = 5;
                                }
                                if(product.product_id == 48){
                                    //旧版阅卷→新版阅卷
                                    new_product_name = '二一阅卷'
                                    new_product_id = 120;
                                    new_product_code = 121;
                                }
                                if(product.product_id == 95){
                                    //旧版排课→新版排课
                                    new_product_name = '二一排课'
                                    new_product_id = 105;
                                    new_product_code = 105;
                                }
                                // if(product.product_id == 111){
                                //     //旧版学业评价→新版学业评价
                                //     new_product_name = '新版学业评价'
                                //     new_product_id = 126;
                                //     new_product_code = 126;
                                // }
                            }
                            product_ids.push(new_product_id);
                            this.financeForm.products.push({
                                ...product, // 保留原始对象的其他属性
                                id: new_product_id,
                                old_price: product.price,
                                refund_amount: 0,
                                product_id: new_product_id,
                                product_name: new_product_name,
                                name: new_product_name,
                                product_code: new_product_code,
                                code: new_product_code,
                            });
                        }
                    }
                    
                    // this.financeForm.products = res.data['products'].map(product => ({
                    //     ...product, // 保留原始对象的其他属性
                    //     id: product.product_id,
                    //     old_price: product.price,
                    //     refund_amount: 0,
                    // }));

                    this.productChecked = _.map(this.financeForm.products, 'product_id');
                    this.getTargetOrder();
                    this.setGroupedProducts();
                    this.productCheckeds();
                    this.getCustomerContracts();
                    
                    this.financeForm.user.forEach((item, index) => {
                        if (item.is_cooperator == 0) {
                            this.financeForm.sale = item.user_id;
                            this.financeForm.sale_name = item.name;
                        }
                        item.no = index + 1;
                    });
                    
                    /**
                     * 放开所有编辑
                     * @type {boolean}
                     */
                    if (this.Acs('/order/supervisorProduct') || this.Acs('/order/supervisorFinance')) this.financeForm.is_submit = false;
                    if (this.Acs('/order/supervisorContract')) this.contractForm.is_submit = false;
                    
                    /**
                     * 续费订单
                     */
                    if (this.$route.path == '/order/renew') {
                        this.financeForm.type = this.config.TYPE_RENEW;
                        this.financeForm.renew_id = this.order.id;
                        this.financeForm.plan_pay = [];
                        this.financeForm.is_submit = false;
                        this.contractForm.is_submit = false;
                    }else if (this.$route.path == '/order/create'){
                        //如果是创建订单走到这里电话，肯定是续费类型，而且勾选了续费目标单，所以要允许编辑
                        this.financeForm.type = this.config.TYPE_RENEW;
                        this.financeForm.is_submit = false;
                        this.contractForm.is_submit = false;
                        this.financeForm.plan_pay = [];
                        this.financeForm.invoice = [];
                        this.financeForm.to_renew_amount = 0
                    }else if (this.$route.path == '/order/revise') {//防止重复修订操作
                        let activeName = this.$route.query["type"];
                        switch (activeName) {
                            case 'product':
                                this.financeForm.is_submit = res.data['revise_product'] ? true : false;
                                break;
                            case 'finance':
                                this.financeForm.is_submit = res.data['revise_finance']==1 ? true : false;
                                break;
                            case 'contract':
                                this.contractForm.is_submit = res.data['revise_contract']==1 ? true : false;
                                break;
                            default:
                                this.$message('修订类型有误,请重试！——————~');
                                break;
                        }
                    }

                    if(this.financeForm.type == this.config.TYPE_RENEW && (this.$route.path == '/order/renew' || this.$route.path == '/order/create')){
                        this.financeForm.products = this.financeForm.products.map(product => ({
                            ...product, // 保留原始对象的其他属性
                            start_at_fomat: '',
                            end_at_fomat: '',
                            start_at: '',
                            end_at: '',
                            effect_at: [],
                        }));
                    }
                    // console.log(this.financeForm, res.data);
                });
            },

            setGroupedProducts() {
                let grouped = {};

                if (!this.productList) {
                    return [];
                }

                this.productList.forEach((product) => {
                    const type_name = product.type_name || '未分类';
                    if (!grouped[type_name]) {
                        grouped[type_name] = {
                            type_id: product.type_id,
                            type_name,
                            products: [],
                            checkAll: false,
                            checkedCities: [],
                        };
                    }
                    if(this.productChecked.includes(product.id)){
                        grouped[type_name].checkedCities.push(product.id);
                    }
                    grouped[type_name].products.push(product);
                });

                let groupsArray = Object.values(grouped).map((group) => {
                    group.isIndeterminate = group.checkedCities.length > 0 && group.checkedCities.length < group.products.length;
                    group.checkAll = group.checkedCities.length === group.products.length;
                    return group;
                });

                groupsArray.sort((a, b) => {
                    const type_idA = typeof a.type_id === 'string' ? a.type_id : String(a.type_id);
                    const type_idB = typeof b.type_id === 'string' ? b.type_id : String(b.type_id);
                    return type_idA.localeCompare(type_idB);
                });
                this.groupedProducts = groupsArray;
            },

            handleCheckedCitiesChange(productGroup) {
                /**
                 * 先有客户再有产品
                 */
                 if (!this.customer_id) {
                    this.productChecked = [];
                    this.$message({
                        message: '请填写客户名称 ，再进行产品选择',
                        type: 'warning'
                    });
                    return false;
                }
                productGroup.isIndeterminate = productGroup.checkedCities.length > 0 && productGroup.checkedCities.length < productGroup.products.length;
                productGroup.checkAll = productGroup.checkedCities.length === productGroup.products.length;
                
                productGroup.products.forEach(item => {
                    if(!productGroup.checkedCities.includes(item.id)){
                        this.productChecked = this.productChecked.filter(product_id => product_id !== item.id);
                    }else if(!this.productChecked.includes(item.id)){
                        this.productChecked.push(item.id);
                    }
                });
                this.productCheckeds();
                // console.log('点击单个：', productGroup, this.productChecked);
            },

            handleCheckAllChange(productGroup) {
                /**
                 * 先有客户再有产品
                 */
                 if (!this.customer_id) {
                    this.productChecked = [];
                    this.$message({
                        message: '请填写客户名称 ，再进行产品选择',
                        type: 'warning'
                    });
                    return false;
                }
                productGroup.checkedCities = productGroup.checkAll ? productGroup.products.map(product => product.id) : [];
                //全部选中
                if(productGroup.checkAll){
                    productGroup.checkedCities.forEach(product_id => {
                        if(!this.productChecked.includes(product_id)){
                            this.productChecked.push(product_id)
                        }
                    });
                }else{
                    productGroup.products.forEach(item => {
                        this.productChecked = this.productChecked.filter(product_id => product_id !== item.id);
                    });
                }
                this.productCheckeds();
                // console.log('点击全选：', productGroup, this.productChecked);
                
            },

            setToRenewAmount(){
                if(this.financeForm.type == this.config.TYPE_RENEW){
                    //只统计：校网通,在线组卷,校本2，脚本3，价格总和
                    var targetProductIds = [1, 2, 4, 5];
                    const order = this.target_orders.find(order => order.id == this.financeForm.target_id);
                    // 检查是否找到了对象
                    if (order) {
                        var totalPrice = order.products.reduce(function(total, product) {
                            return targetProductIds.includes(product.product_id) ? total + (Math.round(parseFloat(product.price) * 100) / 100) : total;
                        }, 0);
                        this.financeForm.to_renew_amount = totalPrice > 0 ? totalPrice : 0;
                        if (this.$route.path == '/order/create' || this.$route.path == '/order/renew'){
                            //特殊要求：续费完成额，取指定订单的应续金额，（为什么会这么改呢：因为只是给个参考值）
                            this.financeForm.user.forEach(item=>{
                                if(item.is_cooperator == 0){
                                    item.finish_amount = totalPrice;
                                }
                            });
                            // this.financeForm.finish_amount = totalPrice;
                        }
                        // console.log(this.financeForm.to_renew_amount, this.target_orders, order, totalPrice, this.financeForm.target_id);
                    }
                }else{
                    this.financeForm.to_renew_amount = 0;
                }
            },

            handleDeleteProduct(id) {
                this.$confirm('此操作是删除操作, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: true
                }).then(() => {
                    this.financeForm.products = this.financeForm.products.filter(function (item) {
                        return item.id != id;
                    });
                    this.productChecked = this.productChecked.filter(item => {
                        return item != id;
                    })
                    this.setGroupedProducts();
                    this.productCheckeds();
                }).catch(() => {

                });
            },

            //设置数字化校园默认时间，取所有产品里面最早开始时间和最晚开始时间
            setDefaultSzxyData(){
                // console.log('setDefaultSzxyData：', this.financeForm.products);
                let product = null;
                this.financeForm.products.forEach(item => {
                    if(!product){
                        product = item;
                    }
                    // console.log('结束时间：', product, product.end_at < item.end_at, product.end_at, item.end_at);
                    if(product.end_at < item.end_at && item.code != 11){
                        product = item;
                    }
                });
                const product11 = this.financeForm.products.find(item => item.code == 11);
                if (product11) {
                    this.$set(product11, 'start_at', product.start_at);
                    this.$set(product11, 'end_at', product.end_at);
                    this.$set(product11, 'effect_at', product.effect_at);
                    this.$set(product11, 'start_at_fomat', product.effect_at[0]);
                    this.$set(product11, 'end_at_fomat', product.effect_at[1]);
                    this.$set(product11, 'price', 0);
                }
                this.financeForm.contract_time = product ? product.effect_at : [];
            },

            priceChange(row){
                let old_price = (Math.round(parseFloat(row.old_price) * 100) / 100);
                let price = (Math.round(parseFloat(row.price) * 100) / 100);
                if(this.financeForm.revise_type == 'refund' && price > old_price){
                    this.$message({
                        message: row.product_name + " 的价格填写错误, 退款修订只能下调产品价格",
                        type: "error"
                    });
                    row.price = row.old_price;
                    return;
                }
                // console.log('priceChange:', row.price, row.old_price);
                this.handleMoney();
            },

            batchSetTime(val){
                // console.log('batchSetTime：', this.financeForm.products);
                this.financeForm.products = this.financeForm.products.map(product => ({
                    ...product, // 保留原始对象的其他属性
                    start_at_fomat: val[0],
                    end_at_fomat: val[1],
                    start_at: new Date(val[0]).getTime(),
                    end_at: new Date(val[1]).getTime(),
                    effect_at: val,
                }));
                this.setDefaultSzxyData();
            },

            timeChange(val, row){
                // console.log('timeChange:', val, row);
                const product = this.financeForm.products.find(product => product.code == row.code);
                if (product) {
                    this.$set(product, 'start_at_fomat', val[0]);
                    this.$set(product, 'end_at_fomat', val[1]);
                    this.$set(product, 'effect_at', val);
                    this.$set(product, 'start_at', new Date(val[0] + ' 00:00:00').getTime());
                    this.$set(product, 'end_at', new Date(val[1] + ' 00:00:00').getTime());
                }
                this.setDefaultSzxyData();
            },

            handleDelCorp(row) {
                if(row.is_cooperator == 0){
                    this.$message({
                        message: "订单负责人无法删除！",
                        type: "error"
                    });
                    return false;
                }
                if (this.$route.path == '/order/edit' || this.$route.path == '/order/revise') {
                    this.$confirm('此操作是删除操作, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                        center: true
                    }).then(() => {
                        this.user_loading = true;
                        OrderService.delCorp({id: row.id}).then((res) => {
                            if (res.code == 0) {
                                this.financeForm.user = this.financeForm.user.filter(function (item) {
                                    return item.no != row.no;
                                });
                            }
                            this.user_loading = false;
                        });
                    })
                } else {
                    this.financeForm.user = this.financeForm.user.filter(function (item) {
                        return item.no != row.no;
                    });
                }
            },

            CorpHandleChange($event, row){
                console.log('CorpHandleChange: ', $event, row);
                this.financeForm.user.forEach(item=>{
                    if(item.no == row.no){
                        item.user_id = $event.id;
                        item.name = $event.name;
                        if(item.is_cooperator == 0){
                            this.financeForm.sale = item.user_id;
                            this.financeForm.sale_name = item.name;
                        }
                    }
                });
            },

            setProductIds(){
                //旧版阅卷→新版阅卷 旧版排课→新版排课 旧版学业评价→新版学业评价
                if (this.$route.path == '/order/create' || this.$route.path == '/order/renew'){
                    if(!this.productChecked.includes(11)){
                        //创建订单时-默认选中数字化校园
                        this.productChecked.push(11);
                    }
                    // if(this.productChecked.includes(4)){
                    //     // const product4 = this.financeForm.products.find(item => item.product_id == 4);
                    //     // if (product4) {
                    //     //     this.$set(product4, 'product_id', 5);
                    //     //     this.$set(product4, 'product_id', 5);
                    //     // }
                    //     //校本2→校本3
                    //     this.productChecked[this.productChecked.indexOf(4)] = 5;
                    // }
                    // if(this.productChecked.includes(48)){
                    //     //旧版阅卷→新版阅卷
                    //     this.productChecked[this.productChecked.indexOf(48)] = 120;
                    // }
                    // if(this.productChecked.includes(95)){
                    //     //旧版排课→新版排课
                    //     this.productChecked[this.productChecked.indexOf(95)] = 105;
                    // }
                    // if(this.productChecked.includes(111)){
                    //     // const product111 = this.financeForm.products.find(item => item.product_id == 111);
                    //     // if (product111) {
                    //     //     this.$set(product111, 'product_id', 126);
                    //     // }
                    //     //旧版学业评价→新版学业评价
                    //     this.productChecked[this.productChecked.indexOf(111)] = 126;
                    // }
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/order/form.vue